<template xmlns="http://www.w3.org/1999/html">
    <div class="dark:text-white-dark text-center ltr:sm:text-left rtl:sm:text-right p-6 pt-0 pb-2 mt-auto">
        © {{ new Date().getFullYear() }}. Gold Alzaky All rights reserved.
    </div>

    <div
        v-if="appStore.showGoldPricesBar && currencySymbol.length > 0"
        class="hidden md:flex relative sticky bottom-0 w-full bg-gradient-to-r from-yellow-700 to-yellow-600 text-white shadow-lg z-49 transition-transform duration-300 translate-y-0">
        <div class="container mx-auto px-4 py-1">
            <div class="flex items-center justify-center">
                <div class="flex items-center space-x-6 rtl:space-x-reverse">
                    <div class="flex items-center space-x-2 rtl:space-x-reverse">
                        <i v-if="collect(goldPrices).isNotEmpty()" class="pi pi-chart-line" />
                        <i v-else class="pi pi pi-spin pi-spinner" />
                        <span class="font-bold">أسعار الذهب اليوم</span>
                    </div>
                    <div class="flex items-center space-x-4 rtl:space-x-reverse text-sm">
                        <div>
                            <span class="font-semibold pl-1">الأونصة:</span>
                            {{ goldPrices.ounce || '--' }}$
                        </div>
                        <div>
                            <span class="font-semibold float-right pl-1">24K:</span>
                            <span>{{ goldPrices[24] || '--' }}&lrm;{{ currencySymbol }}</span>
                        </div>
                        <div>
                            <span class="font-semibold float-right pl-1">22K:</span>
                            <span>{{ goldPrices[22] || '--' }}&lrm;{{ currencySymbol }}</span>
                        </div>
                        <div>
                            <span class="font-semibold float-right pl-1">21K:</span>
                            <span>{{ goldPrices[21] || '--' }}&lrm;{{ currencySymbol }}</span>
                        </div>
                        <div>
                            <span class="font-semibold float-right pl-1">18K:</span>
                            <span>{{ goldPrices[18] || '--' }}&lrm;{{ currencySymbol }}</span>
                        </div>
                        <div class="pr-10">
                            <i
                                class="pi pi-eye-slash hover:bg-yellow-700 rounded p-1"
                                @click="appStore.toggleGoldPricesBar"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
    import { ref } from 'vue';
    import { useAuthStore } from '@/stores/auth';
    import collect from 'collect.js';
    import { useAssetsStore } from '@/stores/assets';
    import { useAppStore } from '@/stores';
    import { useBranchesStore } from '@/stores/branches';

    const appStore = useAppStore();
    const authStore = useAuthStore();
    const assetsStore = useAssetsStore();
    const branchesStore = useBranchesStore();

    // Gold Prices
    const goldPrices = ref({});
    const goldPricesLoading = ref(true);
    const currencySymbol = ref('$');

    const getGoldPrices = (force = false) => {
        if (!force && !appStore.showGoldPricesBar) {
            return;
        }

        goldPricesLoading.value = true;

        authStore.request().get('/api/assets/gold-prices').then(({ data }) => {
            goldPrices.value = data.prices;
            currencySymbol.value = data.prices.currency_code === 'USD' ? '$' : assetsStore.getAsset(data.prices.currency_code)?.currency.symbol_ar;

            if (branchesStore.currentBranch?.auto_update_gold_prices) {
                assetsStore.updateGoldPrices(data.prices);
            }

            goldPricesLoading.value = false;
        });
    };

    getGoldPrices(true);
    setInterval(getGoldPrices, 5 * 60 * 1000);
</script>
